import styled from "styled-components";

export const StyledLabel = styled.label`
    display: block;
    font-size: 14px;
    font-weight: 300;
    margin-bottom: 8px;
    position: relative;

    &.Disabled {
        color: ${p => p.theme.c.disabled};
    }

    &.Center {
        text-align: center;
    }
`;

export const Required = styled.span`
    font-weight: 600;
`;
